const imageData = [
  {
    "id": 1,
    "title": "Plages Roses",
    "author": "Amédée Julien Marcel‑Clément",
    "description": "Olio su tela (50×61 cm), datato fine XIX‑inizio XX secolo, scena costiera, collezione privata; comparso in asta il 27 aprile 1999.",
    "imageUrl": "/paintingsimages/Amédée_Julien_Marcel-Clemént_Plages_Rose.jpg"
  },
  {
    "id": 2,
    "title": "Bird",
    "author": "Benjamin Björklund",
    "description": "Dipinto recente dell’artista svedese (nato nel 1986) che ritrae un uccello, tipico della sua poetica di animali isolati in tavolozze fredde e malinconiche.",
    "imageUrl": "/paintingsimages/Benjamin_Björklund_Bird.jpg"
  },
  {
    "id": 3,
    "title": "Frog",
    "author": "Benjamin Björklund",
    "description": "Opera raffigurante una rana, coerente con l’interesse ricorrente dell’artista per animali — cani, mucche, ratti, uccelli e rane.",
    "imageUrl": "/paintingsimages/Benjamin_Björklund_Frog.jpg"
  },
  {
    "id": 4,
    "title": "Mouse",
    "author": "Benjamin Björklund",
    "description": "Raffigura un topo; Björklund dipinge regolarmente piccoli animali, spesso evocando una sfera intima e misteriosa.",
    "imageUrl": "/paintingsimages/Benjamin_Björklund_Mouse.jpg"
  },
  {
    "id": 5,
    "title": "Tramonto",
    "author": "Camille Pissarro",
    "description": "Probabile versione del tramonto a Rouen o altro paesaggio in luce calante; Pissarro (1830–1903) fu figura di spicco dell’Impressionismo e Neo‑Impressionismo.",
    "imageUrl": "/paintingsimages/Camille_Pissarro_Tramonto.jpeg"
  },
  {
    "id": 6,
    "title": "Il sole",
    "author": "Edvard Munch",
    "description": "Dipinto espressionista (olio su tela, 1910–13 circa) raffigurante un sole ardente e paesaggio luminoso, dimensioni ca.162×205 cm.",
    "imageUrl": "/paintingsimages/Edvard_Munch_Il_sole.jpg"
  },
  {
    "id": 7,
    "title": "La Senna a Saint‑Cloud",
    "author": "Edvard Munch",
    "description": null,
    "imageUrl": "/paintingsimages/Edvard_Munch_La_Senna_a_Saint_Cloud.jpg"
  },
  {
    "id": 8,
    "title": "Notte Stellata",
    "author": "Edvard Munch",
    "description": null,
    "imageUrl": "/paintingsimages/Edvard_Munch_Notte_Stellata.jpg"
  },
  {
    "id": 9,
    "title": "Moonlight",
    "author": "Edward Moran",
    "description": null,
    "imageUrl": "/paintingsimages/Edward_Moran_Moonlight.png"
  },
  {
    "id": 10,
    "title": "Levitation",
    "author": "Egon Schiele",
    "description": null,
    "imageUrl": "/paintingsimages/Egon_Schiele_Levitation.jpg"
  },
  {
    "id": 11,
    "title": "Memoir",
    "author": "Fan Ho",
    "description": null,
    "imageUrl": "/paintingsimages/Fan_Ho_Memoir.jpg"
  },
  {
    "id": 12,
    "title": "La danzatrice spagnola",
    "author": "Giovanni Boldini",
    "description": null,
    "imageUrl": "/paintingsimages/Giovanni_Boldini_La_danzatrice_spagnola.jpg"
  },
  {
    "id": 13,
    "title": "Death and Life",
    "author": "Gustav Klimt",
    "description": null,
    "imageUrl": "/paintingsimages/Gustav_Klimt_Death_and_Life.jpg"
  },
  {
    "id": 14,
    "title": "Case of The Footloose Doll",
    "author": "James R. Bingham",
    "description": null,
    "imageUrl": "/paintingsimages/James_R_Bingham_Case_of_The_Footloose_Doll.jpg"
  },
  {
    "id": 15,
    "title": "NYC",
    "author": "Jeremy Mann",
    "description": null,
    "imageUrl": "/paintingsimages/Jeremy_Mann_NYC.jpg"
  },
  {
    "id": 16,
    "title": "Mattina Invernale",
    "author": "Joseph Farquharson",
    "description": null,
    "imageUrl": "/paintingsimages/Joseph_Farquharson_Mattina_Invernale.png"
  },
  {
    "id": 17,
    "title": "Stadttheater und Alleestraße",
    "author": "Ludvig Munthe",
    "description": null,
    "imageUrl": "/paintingsimages/Ludvig_Munthe_Stadttheater_und_Alleestraße.jpg"
  },
  {
    "id": 18,
    "title": "Sopra la città",
    "author": "Marc Chagall",
    "description": null,
    "imageUrl": "/paintingsimages/Marc_Chagall_Sopra_la_città.png"
  },
  {
    "id": 19,
    "title": "Alone Together",
    "author": "Maria Kreyn",
    "description": null,
    "imageUrl": "/paintingsimages/Maria_Kreyn_Alone_Together.jpg"
  },
  {
    "id": 20,
    "title": "Il pittore e la modella",
    "author": "Milo Manara",
    "description": null,
    "imageUrl": "/paintingsimages/Milo_Manara_Il_pittore_e_la_modella.jpg"
  },
  {
    "id": 21,
    "title": "L'onda",
    "author": "Edvard Munch",
    "description": null,
    "imageUrl": "/paintingsimages/Munch_Edvard_L'onda.jpg"
  },
  {
    "id": 22,
    "title": "The waves of love",
    "author": "Edvard Munch",
    "description": null,
    "imageUrl": "/paintingsimages/Munch_The_waves_of_love.png"
  },
  {
    "id": 23,
    "title": "Il vecchio chitarrista cieco",
    "author": "Pablo Picasso",
    "description": null,
    "imageUrl": "/paintingsimages/Picasso_Il_vecchio_chitarrista_cieco.jpg"
  },
  {
    "id": 24,
    "title": "L'Etreinte",
    "author": "Pablo Picasso",
    "description": null,
    "imageUrl": "/paintingsimages/Picasso_L'Etreinte.png"
  },
  {
    "id": 25,
    "title": "Le cabinet anthropomorphique",
    "author": "Salvador Dalí",
    "description": null,
    "imageUrl": "/paintingsimages/Salvador_Dali_Le_cabinet_anthropomorphique.jpg"
  },
  {
    "id": 26,
    "title": "PALLADIOS CORRIDOR OF THALIA",
    "author": "Salvador Dalì",
    "description": null,
    "imageUrl": "/paintingsimages/Salvador_Dalì_PALLADIOS_CORRIDOR_OF_THALIA.jpg"
  },
  {
    "id": 27,
    "title": "The Poor and Money",
    "author": "Vincent van Gogh",
    "description": null,
    "imageUrl": "/paintingsimages/The_Poor_and_Money_Vincent_van_Gogh.jpg"
  },
  {
    "id": 28,
    "title": "Trasparenze",
    "author": "Vicente Romero Redondo",
    "description": null,
    "imageUrl": "/paintingsimages/Vicente_Romero_Redondo_Trasparenze.jpg"
  },
  {
    "id": 29,
    "title": "Country Road",
    "author": "Vincent van Gogh",
    "description": null,
    "imageUrl": "/paintingsimages/Vincent_van_Gogh_Country_Road.jpg"
  },
  {
    "id": 30,
    "title": "Notte stellata",
    "author": "Vincent van Gogh",
    "description": "Olio su tela, giugno 1889; raffigura il cielo notturno da Saint‑Rémy‑de‑Provence, con vortici blu‑gialli, cipressi fiammeggianti e villaggio, icona moderna custodita al MoMA.",
    "imageUrl": "/paintingsimages/Vincent_van_Gogh_Notte_stellata.png"
  },
  {
    "id": 31,
    "title": "Tempesta di neve. Battello a vapore al largo di Harbour's Mouth",
    "author": "William Turner",
    "description": null,
    "imageUrl": "/paintingsimages/William_Turner_Tempesta_di_neve_Battello_a_vapore_al_largo_di_Harbour's_Mouth.jpg"
  }
]
;

export default imageData;